// plugins/element-ui.js

import Vue from 'vue'
import locale from 'element-ui/lib/locale/lang/en'

// 全局引用
// import Element from 'element-ui'

// 按需引用
import {
  Scrollbar,
  Button,
  Input,
  Radio,
  RadioButton,
  RadioGroup,
  DatePicker,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Carousel,
  CarouselItem,
  Collapse,
  CollapseItem,
  Select,
  Option,
  Cascader,
  Form,
  FormItem,
  Pagination,
  Checkbox,
  CheckboxGroup,
  Dialog,
  Badge,
  Image,
  Timeline,
  TimelineItem,
  Tooltip,
  Tabs,
  TabPane,
  Table,
  TableColumn,
  Steps,
  Step,
  Upload,
  Loading,
  Message,
  MessageBox
} from 'element-ui'

// 自定义主题样式(这里我们会在这个文件内引入我们所需的组件的样式)
import '../assets/css/element-variables.scss'

// Vue.use(Element, { locale })
Vue.prototype.$message = Message
Vue.prototype.$message_box = MessageBox
Vue.prototype.$messageBox = MessageBox

// 按需使用
Vue.use(Scrollbar, { locale })
Vue.use(Button, { locale })
Vue.use(Input, { locale })
Vue.use(Radio, { locale })
Vue.use(RadioButton, { locale })
Vue.use(RadioGroup, { locale })
Vue.use(DatePicker, { locale })
Vue.use(Dropdown, { locale })
Vue.use(DropdownMenu, { locale })
Vue.use(DropdownItem, { locale })
Vue.use(Carousel, { locale })
Vue.use(CarouselItem, { locale })
Vue.use(Collapse, { locale })
Vue.use(CollapseItem, { locale })
Vue.use(Select, { locale })
Vue.use(Option, { locale })
Vue.use(Cascader, { locale })
Vue.use(Form, { locale })
Vue.use(FormItem, { locale })
Vue.use(Pagination, { locale })
Vue.use(Checkbox, { locale })
Vue.use(CheckboxGroup, { locale })
Vue.use(Dialog, { locale })
Vue.use(Badge, { locale })
Vue.use(Image, { locale })
Vue.use(Timeline, { locale })
Vue.use(TimelineItem, { locale })
Vue.use(Tooltip, { locale })
Vue.use(Loading, { locale })
Vue.use(Tabs, { locale })
Vue.use(TabPane, { locale })
Vue.use(Table, { locale })
Vue.use(TableColumn, { locale })
Vue.use(Steps, { locale })
Vue.use(Step, { locale })
Vue.use(Upload, { locale })
